import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Loader from '../../../components/loader';
import Button from '../../../external/components/Button/Button';
import Icon from '../../../external/components/Icon/Icon';
import Text from '../../../external/components/Text/Text';
import moneyHelper from '../../../helpers/money-helper';
import networkHelpers from '../../../helpers/network.helpers';
import { State } from '../../../reducers';
import { BigNumberHelper } from '../helpers/BigNumbeHelper';
import { useLpStakingData } from '../hooks/useLpStakingData';
import { UseLpStakingPool } from '../hooks/usePool';
import { LpScreenEnum } from './_Screens';

interface Props {
  withdrawnAmount: string;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setScreen: React.Dispatch<React.SetStateAction<LpScreenEnum>>;
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  button + button {
    margin-left: 1rem;
  }
`;

export function SuccessfulWithdrawLp({ withdrawnAmount, setScreen, setShow }: Props) {
  const [loading, setLoading] = useState(false);
  const { transactionId, currencies } = useSelector(({ stakingPool, basic }: State) => ({
    transactionId: stakingPool.transactionId,
    currencies: basic.currency.USD,
  }));

  const pool = UseLpStakingPool();
  const { rewardTokenSymbol, networkId } = pool;

  const {
    getDailyReward: updateDailyReward,
    getUnstakedBalance: updateUnstakes,
    getRewardsEarned: updateRewards,
  } = useLpStakingData({ pool });

  const init = async () => {
    try {
      setLoading(true);
      await updateDailyReward();
      await updateUnstakes();
      await updateRewards();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <StyledWrapper>
        {loading ? (
          <>
            <Loader />
            <Text dark={true} style={{ marginTop: '1rem' }}>
              Transaction confirmed, updating balances...
            </Text>{' '}
          </>
        ) : (
          <>
            <Icon type='doneDark' width={100}></Icon>

            <Text dark={true}>Withdraw successful</Text>
            <Text dark={true} size='lg' style={{ margin: '0.5rem 0' }}>
              {withdrawnAmount} {rewardTokenSymbol}
            </Text>

            <Text color='green'>
              (
              {moneyHelper.formatUSD(
                BigNumberHelper.multiply(
                  withdrawnAmount || '0',
                  currencies[rewardTokenSymbol] || 0,
                ),
              )}
              )
            </Text>
            <Text style={{ margin: '0.5rem 0' }} dark={true}>
              <a
                rel='noopener noreferrer'
                target='_blank'
                href={`${networkHelpers.findBlockExplorerUrl(networkId)}/tx/${transactionId}`}
              >
                View transaction
                <Icon
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                  type='external'
                />
              </a>
            </Text>

            <StyledButtonContainer>
              <Button
                dark={true}
                variant='secondary'
                onClick={() => setScreen(LpScreenEnum.HOME_SCREEN)}
              >
                View stake
              </Button>
              <Button dark={true} variant='secondary' onClick={() => setShow(false)}>
                Close
              </Button>
            </StyledButtonContainer>
          </>
        )}
      </StyledWrapper>
    </>
  );
}
